// Mirrors backend/models/annie_avatar.py. Values are append-only: the backend rejects anything else.

export enum AssistantAvatarKind {
	Character = "character",
	Human = "human",
}

export enum AssistantAvatarColor {
	Lavender = "lavender",
	Gold = "gold",
	Mint = "mint",
	Coral = "coral",
	Sky = "sky",
	Midnight = "midnight",
	Pumpkin = "pumpkin",
	White = "white",
	Theme = "theme",
}

export enum AssistantAvatarEyes {
	Round = "round",
	Dots = "dots",
	Happy = "happy",
	Wink = "wink",
	Stars = "stars",
}

export enum AssistantAvatarShape {
	Blob = "blob",
	Bean = "bean",
	Drop = "drop",
	Ghost = "ghost",
	Squircle = "squircle",
}

export enum AssistantCharacterAccessory {
	None = "none",
	Cap = "cap",
	Glasses = "glasses",
	Shades = "shades",
	Stethoscope = "stethoscope",
	Headphones = "headphones",
	Coffee = "coffee",
	Flower = "flower",
	WitchHat = "witch_hat",
	PumpkinStem = "pumpkin_stem",
	Vampire = "vampire",
}

export enum AssistantHumanAccessory {
	None = "none",
	Cap = "cap",
	Glasses = "glasses",
	Shades = "shades",
	Stethoscope = "stethoscope",
	Headphones = "headphones",
	HearingAid = "hearing_aid",
	Coffee = "coffee",
	Flower = "flower",
}

export enum AssistantAvatarSkinTone {
	Tone1 = "tone_1",
	Tone2 = "tone_2",
	Tone3 = "tone_3",
	Tone4 = "tone_4",
	Tone5 = "tone_5",
	Tone6 = "tone_6",
}

export enum AssistantAvatarHair {
	Short = "short",
	Bob = "bob",
	Long = "long",
	Curly = "curly",
	Bun = "bun",
	Buzz = "buzz",
}

export enum AssistantAvatarHairColor {
	Black = "black",
	Brown = "brown",
	Chestnut = "chestnut",
	Auburn = "auburn",
	Blonde = "blonde",
	Silver = "silver",
	Pink = "pink",
	Blue = "blue",
}

export enum AssistantAvatarFacialHair {
	None = "none",
	Stubble = "stubble",
	Beard = "beard",
	Mustache = "mustache",
}

export interface AssistantCharacterAvatar {
	kind: AssistantAvatarKind.Character;
	shape: AssistantAvatarShape;
	color: AssistantAvatarColor;
	eyes: AssistantAvatarEyes;
	accessory: AssistantCharacterAccessory;
}

export interface AssistantHumanAvatar {
	kind: AssistantAvatarKind.Human;
	skin_tone: AssistantAvatarSkinTone;
	hair: AssistantAvatarHair;
	hair_color: AssistantAvatarHairColor;
	facial_hair: AssistantAvatarFacialHair;
	color: AssistantAvatarColor;
	eyes: AssistantAvatarEyes;
	accessory: AssistantHumanAccessory;
}

export type AssistantAvatarConfig = AssistantCharacterAvatar | AssistantHumanAvatar;

export enum AssistantAvatarMood {
	Idle = "idle",
	Thinking = "thinking",
	Talking = "talking",
	NeedsYou = "needs_you",
	Done = "done",
	Oops = "oops",
}
